import React from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { AppState, RootState, Dispatcher, DashboardState, AppLanguage } from 'AppTypes'

import { Card } from '@share/components'

type Props = {
  appState: AppState
  dashboardState: DashboardState
  dispatch: Dispatcher
}

const Summary: React.FC<Props> = ({
  appState: {
    language
  },
  dashboardState: {
    storeStatistic
  }
}) => {
  const { t } = useTranslation()
  return (
    <>
      <div className="row mt-4">
        <div className="col-lg-3 col-xs-12 col-sm-12">
          <Card color="red" header={t('dashboard.numberOfStoresFollowerLabel')} bodyClassname="pl-0 pr-0">
            <>
              <div className="d-flex justify-content-center align-items-center">
                <i className="fas fa-user" />
                <span className="big-text">{storeStatistic.getTotalFollowers(language)}</span>{t('cardUnits.persons')}
              </div>
              <div className="text-center">{t('cardElements.lastWeekComparison')} <span className="text-red">{storeStatistic.getFollowersLastWeekChanged(language)}</span></div>
            </>
          </Card>
        </div>
        <div className="col-lg-4 col-xs-12 col-sm-12">
          <Card color="red" header={t('dashboard.numberOfAccessLast30Days')} bodyClassname="pl-0 pr-0">
            <>
              <div className="d-flex justify-content-center align-items-center">
                <i className="fas fa-user" />
                <span className="big-text">{storeStatistic.getLast30DaysVisitorsNumber(language)}</span>{t('cardUnits.persons')}
              </div>
              <div className="text-center">{t('cardElements.lastMonthComparison')} <span className="text-red">{storeStatistic.getVisitorsLast30DaysChanged(language)}</span></div>
            </>
          </Card>
        </div>
        <div className="col-lg-5 col-xs-12 col-sm-12">
          <Card color="blue" header={t('dashboard.categorySalesRanking')} bodyClassname="live-ranking pl-0 pr-0">
            <>
              <div className="row no-gutters" style={{ height: 32 }}>
                <div className="col-6 text-center">
                  <div>
                    <span>{storeStatistic.getSalesRanking(language)}</span>{t('cardUnits.rank')}
                  </div>
                </div>
                <div className="col-6 text-center">
                  <div>
                    <span>{storeStatistic.getSameCategoryStoresNumber(language)}</span>{t('cardUnits.store')}
                  </div>
                </div>
              </div>
              <div className="text-center">{t('cardElements.lastMonthComparison')} <span className="text-red">{storeStatistic.revenueLastMonthChanged}</span></div>
            </>
          </Card>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-lg-7 col-xs-12 col-sm-12">
          <div className="card widgets red">
            <div className="card-header">顧客のユーザー属性</div>
            <div className="card-body pl-0 pr-0">
              <div className="chartjs">
                <img src="/assets/img/chart-img.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-5 col-xs-12 col-sm-12">
          <Card color="blue" header={t('dashboard.popularStoreTrend')} bodyClassname="pl-2 pr-2">
            <>
              {t('cardElements.averageSales')} {language === 'en' ? '￥' : null}<span className="mid-text">{storeStatistic.getAverageSalesPrice(language)}</span>{language === 'jp' ? '円 / 1 本' : ' per booking'}<br />
              {t('cardElements.averagePublicVideos')} <span className="mid-text">{storeStatistic.getAveragePublicVideo(language)}</span>
            </>
          </Card>
          <Card color="blue" header={t('dashboard.customerSalesWithVideoDelivery')} bodyClassname="pl-2 pr-2">
            <>
              <div className="d-flex justify-content-between">
                <div className="text-center">
                  <span className="mid-text">{storeStatistic.getReserveNumber(language)}</span>{t('cardUnits.persons')}
                  <div>{t('cardUnits.reserve')}</div>
                </div>
                <div className="text-center">
                  <span className="mid-text">{storeStatistic.getDeliveryNumber(language)}</span>{t('cardUnits.persons')}
                  <div>{t('cardUnits.delivery')}</div>
                </div>
                <div className="text-center">
                  <span className="mid-text">{storeStatistic.getTakeOutNumber(language)}</span>{t('cardUnits.persons')}
                  <div>{t('cardUnits.takeOut')}</div>
                </div>
              </div>
            </>
          </Card>
        </div>
      </div>
    </>
  )
}

export default connect((state: RootState) => ({
  appState: state.app,
  dashboardState: state.dashboard
}))(Summary)
